import '../styles/SlideshowEditorTab.css';
import { useAlert, useRest } from 'react-common';
import { useCallback, useEffect, useState } from 'react';
import { Select, MenuItem, Typography, Menu, TextField, ListItemText } from '@mui/material';
import { List, ListItemButton, IconButton, Button  } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { Add } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { FallbackMessage } from 'ds-form';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useNavigate } from 'react-router-dom';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';


const SlideshowEditorTab = ({activeSlideshow, activeSlideshowID, setActiveSlideshowID, slideshows, canModify, slides, activeSlideID, setActiveSlideID, setIsOpenDeleteModal, refreshSlideshows, setIsOpenSlideshowEdit, getSlides, setSlideshowDelete}) => {

    const { t } = useTranslation();
    const navigate = useNavigate();
    const { postData, patchData } = useRest();
    const [editSlideshow, setEditSlideshow] = useState(false)
    const [slideshowTitle, setSlideshowTitle] = useState(activeSlideshow ? activeSlideshow.title : "")
    const [errorMessage, setErrorMessage] = useState("")
    const [anchorEl, setAnchorEl] = useState(null);
    const open = anchorEl;
    const alert = useAlert();

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
      };

    const handleClose = () => {
    setAnchorEl(null);
    };

    const addSlide = useCallback(() => {
        postData('Slide', { slideshowID: activeSlideshowID }).then((newID) => {
            getSlides()
            setActiveSlideID(newID);
        })
    }, [postData, setActiveSlideID, activeSlideshowID, getSlides])

    const addSlideshow = useCallback(() => {
        postData("Slideshow")
            .then((newID) => {
                refreshSlideshows();
                setActiveSlideshowID(newID)
            })
    }, [postData, refreshSlideshows, setActiveSlideshowID])

    const newIndex = (slideID, newIndex) => {
        patchData("Slide/" + slideID, {
            index: newIndex
        }).then(() => {
            getSlides();    
        })   
    }

    const createPresentation = () => {
        postData('Presentation', { slideshowID: activeSlideshowID })
            .then((newID) => navigate(`/presentation/${newID}/presenter`))
    }

    const modifySlideshow = (event) => {
        if(event.key === 'Enter'){
            if(!slideshowTitle || slideshowTitle.length === 0){
                setErrorMessage('title missing')
            } else {
                patchData("Slideshow/" + activeSlideshowID, { title: slideshowTitle })
                    .then(() => {
                        refreshSlideshows()
                        alert.success("Form submission succeed");
                        setEditSlideshow(false)
                    })
                    .catch((e) => {
                        alert.error("Form submission failed");
                    }
                );
            }    
        } 
    }

    useEffect(() => {
        if(activeSlideshow){
            setSlideshowTitle(activeSlideshow.title)    
        }
    }, [activeSlideshow])
    
    return (
        
        <div className="slideshowBarContainer">
            <div className="slideshowContainer">
                <Typography variant="h6">{t("myPresentations")}</Typography>
                <div className="slideshowSelectContainer">
                    <Select
                        value={activeSlideshowID}
                        onChange={(event) => setActiveSlideshowID(event.target.value)}
                        className="slideshowSelect"
                        displayEmpty
                        renderValue={() => {
                            if (activeSlideshow) {
                              return <em>{activeSlideshow.title}</em>
                            } 
                            return <em>{t("selectPresentation")}</em>;
                        }}
                    >
                        {!slideshows.length ?
                            <div className="fallbackMessageContainer">
                            <FallbackMessage >{t("slideshowAccess")}</FallbackMessage>  
                            </div>
                            :
                            slideshows.map((slideshow) => (
                                <MenuItem key={slideshow.id} value={slideshow.id}>
                                    {slideshow.title}
                                </MenuItem>
                            ))
                        }
                    </Select>
                    <IconButton size="small" onClick={addSlideshow}>
                        <Add color="action" fontSize="small"/>    
                    </IconButton>    
                </div>
            </div>
            {activeSlideshow &&
                <div className="slideshowSettingsContainer">
                    {editSlideshow ? 
                        <TextField 
                            value={slideshowTitle}
                            error={errorMessage.length > 0} 
                            helperText={errorMessage ? errorMessage : ""}
                            onChange={(event) => {setSlideshowTitle(event.target.value); setErrorMessage("")}}
                            onKeyDown={modifySlideshow}
                            inputProps={{ maxLength: 20 }}
                        />
                        : 
                        <Typography 
                            variant="h6" 
                            onClick={() => setEditSlideshow(true)}
                            style={{cursor: 'pointer'}}
                        >
                            {activeSlideshow.title}
                        </Typography>
                    }
                    
                    {canModify &&
                        <IconButton 
                            size="small" 
                            id="basic-button"
                            aria-controls={open ? 'basic-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={open ? 'true' : undefined}
                            onClick={handleClick}
                        >
                            <MoreVertIcon color="action"/>    
                        </IconButton>  
                    }
                    <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        MenuListProps={{
                          'aria-labelledby': 'basic-button',
                        }}
                    >
                        <MenuItem 
                            className="menuItem"
                            onClick={createPresentation}
                        >
                            <OndemandVideoIcon className="menuIcon"/>
                            {t('broadcast')}
                        </MenuItem>
                        <MenuItem 
                            className="menuItem"
                            onClick={() => {setIsOpenSlideshowEdit(true); setAnchorEl(false)}}
                        >
                            <PersonAddIcon className="menuIcon"/>
                            {t('access')}
                        </MenuItem>
                        <MenuItem 
                            className="menuItem"
                            onClick={() => {setSlideshowDelete(true); setIsOpenDeleteModal(true); setAnchorEl(false)}}
                            style={{color: 'red'}}
                        >
                            <DeleteIcon className="menuIcon"/>
                            {t('delete')}
                        </MenuItem>
                    </Menu> 
                </div>
            }
            
            {canModify &&
            <div className="addSlideContainer">
                <Button className="addSlideButton" variant="contained" color="primary" onClick={addSlide} startIcon={<Add />}>{t("newSlide")}</Button>
            </div>
            }
            <div>
                {slides && slides.length > 0 &&
                    <List>
                        {slides.map((slide) => (
                            <ListItemButton selected={slide.id === activeSlideID} key={slide.id} onClick={() => setActiveSlideID(slide.id)}>
                                {canModify &&
                                    <div className="buttonsIndexContainer">
                                        <IconButton size="small" edge="start" onClick={() => newIndex(slide.id, slide.index - 1)}>
                                            <ArrowDropUpIcon color="disabled"/>    
                                        </IconButton>
                                        <IconButton size="small" edge="start" onClick={() => newIndex(slide.id, slide.index + 1)}>
                                            <ArrowDropDownIcon color="disabled"/>    
                                        </IconButton>
                                    </div>
                                }
                                <ListItemText primary={slide.title} />
                                {canModify &&
                                    <IconButton edge="end" aria-label="delete" onClick={() => setIsOpenDeleteModal(true)}>
                                        <DeleteIcon color="disabled" fontSize="small" />
                                    </IconButton>
                                } 
                            </ListItemButton>
                        ))}
                    </List>
                }
            </div> 
        </div>     
    )
}

export default SlideshowEditorTab;